module.exports = __webpack_public_path__ + "static/media/cloud-computing.1db01187.svg";